import { useEffect } from "react";
import { useAppDispatch } from "app/hooks";
import { setLastViewedUser } from "pages/users/usersSlice";
import UserData from "./components/UserData";
import CompletedInstallations from "./components/CompletedInstallations";
import PageLayout from "components/PageLayout";
import Breadcrumbs from "features/breadcrumbs/Breadcrumbs";
import PageTitle from "components/PageTitle";
import { useGetUserByIdQuery } from "app/api/users";
import useAssertParams from "hooks/useAssertParams";
import LoadingPage from "pages/loading/LoadingPage";
import UserProvider from "context/UserContext";
import ErrorPage from "pages/error/ErrorPage";
import { UserRole } from "features/auth/types/user";

export type ShowUserParams = {
  userId: string;
};

const ShowUser: React.FC = () => {
  const dispatch = useAppDispatch();
  const { userId } = useAssertParams<ShowUserParams>("userId");
  const { data: user, isLoading } = useGetUserByIdQuery({ userId });

  const isInstaller =
    user?.role === UserRole.INTERNAL_INSTALLER || user?.role === UserRole.EXTERNAL_INSTALLER;

  useEffect(() => {
    if (user) dispatch(setLastViewedUser(user.id));
  }, [dispatch, user]);

  if (isLoading) return <LoadingPage />;
  if (!user) return <ErrorPage.NotFound />;

  return (
    <PageLayout>
      <Breadcrumbs skipCurrent />

      <PageTitle sx={{ mt: 0 }}>{user.userName}</PageTitle>

      <UserProvider user={user}>
        <UserData />

        {isInstaller && <CompletedInstallations />}
      </UserProvider>
    </PageLayout>
  );
};

export default ShowUser;
